export default __webpack_public_path__ + "static/media/background_white_graphics_square_left_01.d7cec897.png";